import React from 'react';
import { Badge } from 'components/ui/badge';
import { STATUS_LABELS, STATUS_LABELS_EN, STATUS_COLORS } from 'lib/format';
import { useLanguage } from 'lib/i18n';

export const StatusBadge = ({ status, className = '' }) => {
  const { language } = useLanguage();
  const labels = language === 'en' ? STATUS_LABELS_EN : STATUS_LABELS;
  const label = labels[status] || status;
  const color = STATUS_COLORS[status] || 'bg-gray-100 text-gray-800';
  return (
    <Badge className={`${color} border-0 font-medium ${className}`} data-testid={`status-badge-${status}`}>
      {label}
    </Badge>
  );
};
